import SpriteSymbol from "../../../../../../../sfra-webpack-builder/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../sfra-webpack-builder/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wishlistOutline",
  "use": "wishlistOutline-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"wishlistOutline\"><path d=\"m5.944 11.26 4.57-4.998.097-.103c1.185-1.295 1.185-3.412 0-4.707-1.162-1.27-3.025-1.27-4.187 0l-.025.029-.018.02-.075.08-.37.387-.36-.395c-1.162-1.27-3.025-1.27-4.187 0-1.185 1.295-1.185 3.412 0 4.707l4.555 4.98Z\" stroke=\"#57585B\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol